import { render, staticRenderFns } from "./MajorityAutocomplete.vue?vue&type=template&id=6d6b4f90&"
import script from "./MajorityAutocomplete.vue?vue&type=script&lang=js&"
export * from "./MajorityAutocomplete.vue?vue&type=script&lang=js&"
import style0 from "./MajorityAutocomplete.vue?vue&type=style&index=0&id=6d6b4f90&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports